
$(document).ready(function() {
  function checkBeefInCart() {
    $.getJSON('/cart.js', function(cartData) {
      var beefItems = [];

      $.each(cartData.items, function(i, item) {
        var type  = (item.product_type || '').toLowerCase().trim();
        var title = (item.title || '').toLowerCase().trim();

        if (type === 'beef' || title.indexOf('beef') !== -1) {
          beefItems.push(item.title);
        }
      });

      if (beefItems.length > 0) {
        $('.cart-page-beef-products-wrapper').show();
      } else {
        $('.cart-page-beef-products-wrapper').hide();
      }
    });
  }
  checkBeefInCart();

  $(document).on('click', '.ajax-cart__toggle, [href="/cart"]', function() {
    setTimeout(function() {
      checkBeefInCart();
    }, 500);
  });

  $(document).on('click', '.cart-drawer__item-delete', function() {
    setTimeout(function() {
      checkBeefInCart();
    },1500);
  });

  $(document).on('click', '[data-cart-submit], [name="add"]', function() {
    setTimeout(function() {
      checkBeefInCart();
    }, 500);
  });

});